import React from 'react';
import { StringHelpers } from 'helpers/stringHelpers';
import { useCart } from 'frontastic';
import Preview from '../wrapper';

const DeliveryPreview = () => {
  const { data } = useCart();

  return (
    <Preview>
      <div className="flex items-center justify-between border border-neutral-400 p-16">
        <div className="border-l-4 border-ag_color-text_green py-18 pl-18">
          <p className="text-14 font-medium">{StringHelpers.titleCaseString(data?.custom?.deliveryOption || '')}</p>
        </div>
      </div>
    </Preview>
  );
};

export default DeliveryPreview;
